import { Component, OnInit } from '@angular/core';
import {DMenuService} from "../../../services/menu.service";

@Component({
  selector: 'site-footer',
  templateUrl: './site-footer.component.html'
})
export class SiteFooterComponent implements OnInit {
    public currentYear: number = new Date().getFullYear();

    public menuItems: Object[] = [];
    public footer_items_one: Object[] = [
        {'title':'Over Dermabase','url':'/over-dermabase'},
        {'title':'Onafhankelijk','url':'/onafhankelijkheid'},
        {'title':'Over Dermabase','url':'/over-dermabase'},
        {'title':'Over Dermabase','url':'/over-dermabase'},
    ];

    constructor(private menuService: DMenuService) { }

    ngOnInit() {
        this.menuService.get('footer').subscribe((res) => {
            this.menuItems = res;
        });
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/_blocks/site-footer/site-footer.component.ts